<script lang="ts">
  export let value: number;
  export let max: number;
  export let highest: number | undefined = undefined;

  $: percentage = (value / max) * 100;
</script>

<div class="meter">
  <div class="bar" data-highest={highest === value} style="width: {percentage}%" />
</div>

<style lang="postcss">
  .meter {
    background-color: var(--mauve-a3);
    border: 1px solid var(--border-normal);
    width: 100%;
    border-radius: var(--radius-1);
    overflow: hidden;
  }
  .bar {
    height: var(--space-3);
    background-color: var(--red-10);

    &[data-highest='true'] {
      background-color: var(--orange-9);
    }
  }
  :global(.dark) .bar {
    &[data-highest='true'] {
      background-color: var(--yellow-10);
    }
  }
</style>
